enum ACTIONS {
    FETCH_EXTENSIONS = 'FETCH_EXTENSIONS',
    CREATE_EXTENSION = 'CREATE_EXTENSION',
    PATCH_EXTENSION = 'PATCH_EXTENSION'
}

export default ACTIONS;